import React, { useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import { useNavigationContext } from 'Components/ComponentLibrary/Organisms/NavigationWithContext/NavigationContext';
import {
  FDEmphasisSurface, FDFacetLogo, FDSecondaryActionIconButton, FDStack,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('RoadmapDeliverableNavigation', (theme) => ({
  drawerPaper: {
    width: '90%',
    minWidth: 300,
    maxWidth: 350,
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'flex-start',
    '& .FD-MuiIconButton-root': {
      padding: 0,
      width: 'unset',
      marginLeft: '-2%', // The MUI close icon has some extra spacing on its sides - let's remove it so that it can be aligned with the Facet logo
    },
  },
  background: {
    backgroundColor: theme.palette.facet.primaryBlue,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    height: '100%',
    width: '100%',
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexGrow: 1,
    marginTop: theme.spacing(1),
  },
}));

const RoadmapDeliverableNavigation = ({ open }) => {
  const classes = useStyles();
  const { setOpen, setNavPortal } = useNavigationContext();

  const closeDrawer = () => setOpen(false);

  const setRef = useCallback((node) => {
    setNavPortal(node);
    return () => setNavPortal(null);
  }, []);

  return (
    <Drawer
      anchor="left"
      open={open}
      ModalProps={{ onBackdropClick: closeDrawer }}
      PaperProps={{ className: classNames(classes.drawerPaper, classes.background) }}
    >
      <FDEmphasisSurface width="100%" height="100%" flex={1}>{/* Adjusts FD to have the right color scheme */}
        <div className={classes.background}>
          <FDStack direction="column" spacing={3} flex={1} alignItems="flex-start" width="100%">
            <FDStack direction="row" alignItems="center" justifyContent="space-between" width="100%">
              <FDFacetLogo size="md" />
              <FDSecondaryActionIconButton icon="close" onClick={closeDrawer} size="lg" />
            </FDStack>
            <div
              className={classes.content}
              ref={setRef}
            />
          </FDStack>
        </div>
      </FDEmphasisSurface>
    </Drawer>
  );
};

RoadmapDeliverableNavigation.propTypes = {
  open: PropTypes.bool,
};

export default RoadmapDeliverableNavigation;
